"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigProviderMiddleware = void 0;
var PathReporter_1 = require("io-ts/lib/PathReporter");
//https://lorefnon.tech/2018/03/25/typescript-and-validations-at-runtime-boundaries/
//https://github.com/gcanti/io-ts#typescript-integration
var ConfigProviderMiddleware = /** @class */ (function () {
    function ConfigProviderMiddleware() {
    }
    ConfigProviderMiddleware.getConfig = function (url, reqType, scopes) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: url,
                method: "POST",
                data: scopes,
                dataType: "json",
                success: function (jsonObj) {
                    var validationResult = reqType.decode(jsonObj);
                    //ThrowReporter.report(validationResult);                        
                    if (validationResult.isRight()) {
                        resolve(validationResult.value);
                    }
                    else {
                        reject(PathReporter_1.PathReporter.report(validationResult));
                    }
                },
                error: function (e) {
                    var err = e.status + " -  " + e.responseText;
                    reject(err);
                }
            });
        });
    };
    return ConfigProviderMiddleware;
}());
exports.ConfigProviderMiddleware = ConfigProviderMiddleware;
//# sourceMappingURL=ConfigProviderMiddleware.js.map